<template>
  <GenericWrapperChart :config="config">
    <template
      v-if="showFeedbackCard"
      #afterChart
    >
      <FeedbackCard :message="messageFeedbackCard" />
    </template>
  </GenericWrapperChart>
</template>

<script>
import { generateFileName } from '@/utils';
import { FeedbackCard } from '@/components/base';
import { GenericWrapperChart } from '@/components/content/GenericWrapperChart';

export default {
  name: 'SentimentsInTheCommentsOverTime',
  components: {
    GenericWrapperChart,
    FeedbackCard,
  },
  data() {
    return {
      title: this.$t('Charts.sentimentsInTheCommentsOverTime.title'),
      messageFeedbackCard: this.$t('Charts.feedbackCard.messageChartsSentiments'),
    };
  },
  computed: {
    overrideChartOptions() {
      const filename = generateFileName(this.title);

      return {
        exporting: {
          enabled: false,
          sourceWidth: 750,
          filename,
          chartOptions: {
            title: {
              text: this.title,
            },
            chart: {
              spacingLeft: 15,
              spacingRight: 15,
            },
          },
        },
      };
    },
    config() {
      const isLoading = this.$store.state.charts.sentimentsInTheCommentsOverTime.isLoading;
      const title = !isLoading ? this.title : '';
      const description = !isLoading ? this.$t('Charts.sentimentsInTheCommentsOverTime.description') : '';
      const series = this.$store.state.charts.sentimentsInTheCommentsOverTime.data;
      const tooltipConfig = {
        addHeader: true,
        addFooter: false,
        addPercentVariation: false,
      };

      return {
        componentName: 'SentimentsInTheCommentsOverTime',
        title,
        description,
        isLoading,
        hasError: this.$store.state.charts.sentimentsInTheCommentsOverTime.hasError,
        isEmpty: false,
        onError: this.getSentimentsInTheCommentsOverTimeData,
        requestOnMounted: this.getSentimentsInTheCommentsOverTimeData,
        downloadMenu: {
          trackNameOnOpen: 'BM ExportSentimentsInTheCommentsOverTime Graph Open',
          trackNameOnDownload: 'BM ExportSentimentsInTheCommentsOverTime Graph Click',
        },
        chart: {
          type: 'AreaSpline',
          series,
          tooltipConfig,
          overrideChartOptions: this.overrideChartOptions,
          trackNameOnObserve: 'BM SentimentsInTheCommentsOverTime Graph View',
          trackNameOnLegendClick: 'BM SentimentsInTheCommentsOverTime LegendGraph View',
        },
        periodSelector: {
          showPeriodSelector: true,
          onPeriodChange: this.getSentimentsInTheCommentsOverTimeData,
          trackPeriod: 'BM PeriodCommentSentimentsTime Graph Click',
        },
        groupSelector: {
          showGroupSelector: true,
          onGroupChange: this.getSentimentsInTheCommentsOverTimeData,
          trackGroup: 'BM SeletctGroupCommentSentimentsTime Graph Click',
        },
      };
    },
    showFeedbackCard() {
      return this.$store.state.ui.channel.toLowerCase() === 'todas';
    },
  },
  methods: {
    async getSentimentsInTheCommentsOverTimeData({ periodSelected, groupSelected } = {}) {
      await this.$store.dispatch('charts/fetchSentimentsInTheCommentsOverTime', { datePortion: periodSelected, groupSelected });
    },
  },
};
</script>

<style scoped lang='scss'>

::v-deep {
  .highcharts {
    &-custom-tooltip {
      background-color: var(--ds-color-neutral);
    }

    &-tooltip-box {
      fill: none;
    }
  }
}
</style>
